module.exports = __webpack_public_path__ + "img/drawer_user.d5beca60.svg";